import React from "react"

import { button } from "./style"

const Button = props => <button css={button} {...props} />

export default Button
